import { render, staticRenderFns } from "./RtfEditor.vue?vue&type=template&id=1948912c"
import script from "./RtfEditor.vue?vue&type=script&lang=js"
export * from "./RtfEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports